const VISITSVIEW = {
  listClients: "Client list",
  loadMasive: "Bulk upload",
  createClient: "Create customer",
  updateClient: "Update client",
  FORMCLIENT: {
    names: "Names",
    lastName: "Last name",
    EMAILContact: "Contact email",
    optional: "(Optional)",
    address: "Address",
    selectionTypeForm: "*Select the type of forms to be assigned:",
    standarMovil: "Standard (mobile application)",
    botsViky: "Bots (VIKI)",
    selectedForms: "*Select forms",
    searchForm: "Search form...",
    details: "Details",
    update: "To update",
    save: "Save",
    clean: "Clean up",
    address: "Address",
    messagge1: "Verify that the structure of the address is an example: Calle 84 24 - 78, Bogotá",
    client: "Client",
    selectedFormsToClient: "Select the Form(s) for the client",
    errorCreateClient: "Error creating client.",
    updatedClient: "The client has been updated.",
    errorUpdatedClient: "Error updating client.",
    message2: "Verify that the structure of the address is an example: Calle 84 24 - 78, Bogotá",
    message3: "Select the Form(s) for the client",
    createdClient: "The client has been created.",
    errorToCreatedClient: "Error creating client.",
    errorToUpdateClient: "Error updating client."
  },
  LISTCLIENTS: {
    byPage: "Per page",
    client: "Client",
    email: "E-mail",
    phone: "Telephone",
    created: "Registered",
    state: "Condition",
    actions: "Actions",
    deleteUser: "Delete user",
    textConfirm: "Do you really want to delete the user: {name} {lastname}"
  },
  LOADMASIVE: {
    donwloadFormat: "Download format",
    settingExcel: "Excel configuration",
    selectTypeForm: "*Select the type of forms to be assigned::",
    standarMovil: "Standard (mobile application)",
    botsViky: "Bots (VIKI)",
    none: "None",
    howManyClients: "How many clients will you register?",
    OrderEmail: "Do you want to request the E-mail?",
    yes: "Yes",
    no: "No",
    searchForm: "search form...",
    HEADTABLE: {
      names: "NAMES",
      lastNames: "LAST NAME",
      email: "E-MAIL",
      phone: "PHONE",
      address: "DIRECCION",
      details: "DETAIL"
    }
  },
  VISITS: {
    listVisits: "visiting list",
    assignVisit: "assign visit",
    updateVisit: "update visit",
    createVisit: "create visit",

    searchUsuario: "Search user...",
    users: "Users",
    searchClient: "Search client",
    searchVisit: "Search visit",
    filter: "Filter",
    rangeDate: "Date range",
    selectDateInitial: "Select start date",
    selectDateEnd: "Select end date",
    createFilter: "Create Filter",
    assignment: "Assignment",
    messagge1: "The visit has been assigned.",

    scheduleVisit: "Schedule visit",
    nameVisit: "Name of the visit",
    decriptionVisit: "Description of the visit",
    visit: "Visit",
    selectVisit: "Select a visit",

  }
};

export default { VISITSVIEW };
